import { getEnv } from "../utils/env";

const DEV_TOKEN_KEY = "dev_access_token";

export const getAuthApiBaseUrl = (): string =>
  import.meta.env.DEV ? "/auth-api" : (getEnv("VITE_AUTH_API_URL") || "/auth-api");

export const getDevAccessToken = (): string | null => {
  try {
    return localStorage.getItem(DEV_TOKEN_KEY) || getEnv("VITE_DEV_ACCESS_TOKEN") || null;
  } catch {
    return getEnv("VITE_DEV_ACCESS_TOKEN") || null;
  }
};

export async function fetchGoogleAccessToken(): Promise<string | null> {
  const devAccessToken = getDevAccessToken();
  if (devAccessToken) return devAccessToken;

  try {
    const response = await fetch(`${getAuthApiBaseUrl()}/google/token`, {
      credentials: "include",
    });
    if (!response.ok) return null;

    const data = await response.json();
    return typeof data?.accessToken === "string" && data.accessToken.trim()
      ? data.accessToken
      : null;
  } catch {
    return null;
  }
}

export async function getGoogleAuthHeaders(): Promise<Record<string, string>> {
  const accessToken = await fetchGoogleAccessToken();
  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
}
